import React from 'react';
import { motion } from 'framer-motion';
interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export function AnimatedSection({
  children,
  className = '',
  id
}: AnimatedSectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className={`py-10 md:py-14 px-4 sm:px-6 lg:px-8 ${className}`} data-id="element-162">
      <div className="max-w-4xl mx-auto" data-id="element-163">{children}</div>
    </motion.section>;
}